import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { BarLoader } from 'react-spinners';
import { Container, Row, Col } from 'react-grid-system';
import moment from 'moment';

import ActionButton from 'SharedComponents/action-button';
import ModalDialogV3 from 'SharedComponents/modal-dialog-v3';
import RoundUpsAcctsTable from 'SharedComponents/table-roundups-accounts';
import DirectDebitRequestContent from 'SharedComponents/direct-debit-request-content';


import basiqLogo from 'Images/logo-400px-BASIQ.png';
import pokitPalLogo from 'Images/logo-400px-PokitPal.png';
//import privacyImage from 'Images/privacy1-400px.png';
import BYSlogo from 'Images/logo-400px-BoostYourSuper.png'; 
//import consumerDataRightLogo from 'Images/logo-400px-ConsumerDataRight.png'; //working?

import log from "Utils/logger";

import styles from './SetBankAccounts.css';

const SetBankAccountsWrapper = styled.div`${styles}`;

const SetBankAccounts = (
  { onError, 
    roundups,
    registeringNewShopperForRoundups,
    requestConsentLinks,
    requestingConsentLinksRef,
    localActiveBankConsentLink,
    syncShopperDataFromOpenBank,
    deleteBankConnection,
   }) => {
  
  console.log('*SetBankAccounts triggered with roundups: ', roundups);
  console.log('*SetBankAccounts triggered with localActiveBankConsentLink: ', localActiveBankConsentLink);  
  console.log('*SetBankAccounts triggered with requestingConsentLinksRef.current: ', requestingConsentLinksRef.current);
  console.log('*SetBankAccounts triggered with registeringNewShopperForRoundups: ', registeringNewShopperForRoundups);


  const [showModalDialogV3, setShowModalDialogV3] = useState(false);
  const [showDDRViewModal, setShowDDRViewModal] = useState(false);

  const hasAcceptedDDR = roundups?.acceptedRoundupsTerms === true;

  const lastRequestRef = useRef(null);

  const handleConnectBank = () => {
    const links = roundups?.links || [];

    const consentLink = links.find(
      (l) =>
        l?.link_type === 'connect' &&
        !l?.expired
    );

    if (consentLink && !isLinkExpired(consentLink) && consentLink.url) {
      console.log('SetBankAccounts Opening consentLink:', consentLink);
      window.open(consentLink.url, 'width=500,height=500');
      return;
    }

    console.log('SetBankAccounts No valid connect link available');
  };


  const connectYourBankInfoCard = (
    <div className="bank-connection-card">
      <h2 className="title">Connect Your Bank</h2>
      <p className="description">
        Connect your bank so we can calculate round up amounts and transfer them to your super.
      </p>

      <div className="button-container">
        { ( requestingConsentLinksRef.current ) ? (
          <div className="waiting">
            <p>Updating BASIQ Open Banking connection</p>
            <p>Please wait a few seconds....</p>
            <BarLoader sizeUnit={"px"} size={400} color="#000" loading={true} />
          </div>
        ) : !roundups.links ? (
          <div>
            <p>Please wait. Setting up link for BASIQ Open Banking connection</p>
            <BarLoader sizeUnit={"px"} size={400} color="#000" loading={true} />
          </div>
        ) : (
          <>
            <ActionButton
              text="Connect A Bank"
              onClick={() => {
                console.log('SetBankAccounts Connect A Bank CLICKED');
                handleConnectBank();
              }}
              color="#fff"
              large={true}
              disabled={
                (roundups.accountsConnectingStatus !== null &&
                  !roundups.consentLinkStatus)
              }
            />
            <p>
              You will be taken to the BASIQ Open Banking portal to link your bank account.
            </p>
          </>
        )}
      </div>
    </div>
  );

  const manageConsentInfoCard = (

    <div className="bank-connection-card">
    <h2 className="title">Manage Your Open Banking Consent</h2>
    <p> Once provided, your consent lasts for 12 months. You will need to provide your consent again before it expires to ensure uninterrupted Round-Ups service</p>
    <p>
      <strong>Your Consent Expires:</strong>{' '}
      {roundups?.consentExpiresAt &&
        moment.utc(roundups.consentExpiresAt).isAfter(moment.utc())
        ? moment(roundups.consentExpiresAt).format('DD-MMM-YYYY')
        : 'No Active Consent'}
    </p>

    {Array.isArray(roundups?.links) &&
      roundups.links
        .filter(link => link?.action_required && !link?.expired && link?.link_type !== 'connect')
        .slice(0, 3)
        .map((link, index) => {
          const getButtonText = (type) => {
            switch (type) {
              case 'reconnect':
                return 'Reconnect Consent';
              case 'extend':
                return 'Extend Consent';
              case 'manage':
                return 'Manage Consent';
              case 'expired':
                return 'Renew Expired Consent';
              // default:
              //   return 'Open Consent Link';
            }
          };

          return (
            <ActionButton
              key={`${link.link_type}-${index}`}
              text={getButtonText(link.link_type)}
              //onClick={() => window.open(link.url, '_self')}
              onClick={() => window.open(link.url, 'width=500,height=500' )}
              color="#fff"
              large={true}
            />
          );
        })}
    
    </div>

  );

  const shouldShowManageConsentCard =
  Array.isArray(roundups?.links) &&
  roundups.links.some(
    (link) =>
      link?.action_required &&
      !link?.expired &&
      link?.link_type !== 'connect'
  );

  const viewDDRSAInfoCard = (
    <div className="bank-connection-card">
      <h2 className="title">View Zai Australia Direct Debit Request Service Agreement</h2>

      <p className="description">
        Your Direct Debit Request has been accepted.
        You can review your Direct Debit Request and the
        Direct Debit Request Service Agreement at any time
        by clicking the button below.
      </p>

      <ActionButton
        text="View Direct Debit Request"
        onClick={() => {
          console.log(
            'SetBankAccounts - View Direct Debit Request CLICKED'
          );

          setShowDDRViewModal(true);
        }}
        color="#fff"
        large={true}
      />
    </div>
  );


    {/*       <ActionButton
          text="Sync Account Data (test button only)"
          onClick={() =>  handleSyncAccountClick() }
          color="#fff"
          large={true}
        /> */}

      const aboutOpenBankingInfoCard = (
        <div className="bank-connection-card">
          <h2 className="title">About Open Banking</h2>
          <p className="description">Open Banking gives consumers the right to direct their banks to safely share banking data with service providers who are Consumer Data Recepients in order to access new services such as Round Ups.</p>

          <p className="more-detail"><strong>Open Banking Regulation. </strong>Open Banking is mandated and regulated by the Australian Government through the Consumer Data Right (CDR)</p>
          <p className="more-detail"><strong>Accreditation </strong>Australian Consumer and Competition Commission (ACCC) accredits Consumer Data Right Recipients.</p>

          <p className="description">Consumer Data Right follows strict regulations to protect your data and privacy.</p>

          <div className="logo-and-description-container">
            <div className="logo-container">
              <img className="logo" src={pokitPalLogo} alt="Roundups Calculating company" />
            </div>
            <div className="description-container">
              <p><strong>Round-Up Calculations. </strong>Boost Your Super App uses Pokitpal Pty to calculate Round-Ups. Pokitpal Pty Ltd is listed on the ACCC website as a Consumer Data Right Representative of Basiq Pty Ltd.</p>
            </div>
          </div>

          <div className="logo-and-description-container">
            <div className="logo-container">
              <img className="logo" src={basiqLogo} alt="Basiq" />
            </div>
            <div className="description-container">
              <p><strong>Open Banking. </strong>Our Open Banking solution is powered by BASIQ, leaders in Secure Open Banking in Australia. Basiq Pty Ltd is listed on the ACCC Website as an Accredited Data Recipient. </p>
            </div>
          </div>

          <p className="description">You can find out more on the CDR website.</p>
              <ActionButton 
                style={{margin: "10px"}}
                text={"More on CDR Website"}
                large={true}
                onClick={() => window.open(`https://cdr.gov.au/your-rights`, '_blank')}
              />
        </div>
      );

      useEffect(() => {
        const links = roundups.links || [];

        const hasValidLink = (type) =>
          links.some(
            (l) => l?.link_type === type && !isLinkExpired(l)
          );

        const excludeResetDate3Mar26 =
          roundups.consentResetAt &&
          moment.utc(roundups.consentResetAt).isSame(moment.utc('2026-03-03'), 'day') &&
          roundups.consentStatus === 'failed';

        console.log('**SetBankAccounts UseEffect excludeResetDate3Mar26:', excludeResetDate3Mar26);
        console.log('**SetBankAccounts UseEffect consentStatus:', roundups.consentStatus);
        console.log('**SetBankAccounts UseEffect bankConnected:', roundups.bankConnected);

        const shouldSkipRequests =
          requestingConsentLinksRef.current ||
          registeringNewShopperForRoundups;

        if (shouldSkipRequests) {
          console.log('**SetBankAccounts UseEffect skipping - request in progress or registering');
          console.log('**SetBankAccounts UseEffect skipping when requestingConsentLinksRef.current is ', requestingConsentLinksRef.current );
          console.log('**SetBankAccounts UseEffect skipping when registeringNewShopperForRoundups is ', registeringNewShopperForRoundups );
          return;
        }

        const needsReconnect =
          //!hasValidLink('reconnect-consent') &&
          !excludeResetDate3Mar26 &&
          (
            ['failed', 'expired', 'none', 'revoked'].includes(roundups.consentStatus) //||
            //(roundups.consentStatus === 'active' && !roundups.bankConnected)
          );

          if (needsReconnect) {

            const requestKey = `reconnect-${roundups.consentStatus}-${roundups.bankConnected}`;

            if (lastRequestRef.current === requestKey) {
              console.log('**SetBankAccounts UseEffect Skipping duplicate reconnect request');
            } else {
              lastRequestRef.current = requestKey;
              console.log('**SetBankAccounts UseEffect requesting reconnect-consent with roundups:', roundups);
              requestConsentLinks('reconnect-consent');
            }
            return;
          }

        const needsConsent = !hasValidLink('connect');

        if (needsConsent) {
          console.log('**SetBankAccounts UseEffect requesting consent link with roundups:', roundups);
          console.log('**SetBankAccounts UseEffect localActiveBankConsentLink:', localActiveBankConsentLink);

          log({
            event: "System-Notification",
            source: "SetBankAccounts",
            notification: `request consent link with localActiveBankConsentLink: ${localActiveBankConsentLink}`,
            error: null,
          });

          requestConsentLinks('consent');
          return;
        }

        const needsManage =
          roundups.consentStatus === 'active' &&
          roundups.bankConnected &&
          !hasValidLink('manage');

        if (needsManage) {
          console.log('**SetBankAccounts UseEffect requesting manage-consent with roundups:', roundups);
          requestConsentLinks('manage-consent');
          return;
        }

        const needsExtend =
          roundups.consentStatus === 'active' &&
          roundups.bankConnected &&
          roundups.consentExpiresAt &&
          moment.utc(roundups.consentExpiresAt).isBefore(moment.utc().add(11, 'months')) &&
          !hasValidLink('extend');

        if (needsExtend) {
          console.log('**SetBankAccounts UseEffect requesting extend-consent with roundups:', roundups);
          requestConsentLinks('extend-consent');
          return;
        }

        // For testing only. Many not need due to re-connect. But need to check 
        // const needsExpired =
        //   roundups.consentStatus === 'active' &&
        //   roundups.bankConnected &&
        //   roundups.consentExpiresAt &&
        //   moment.utc(roundups.consentExpiresAt).isBefore(moment.utc()) &&
        //   !hasValidLink('expired');

        // if (needsExpired) {
        //   console.log('**SetBankAccounts UseEffect requesting expired-consent with roundups:', roundups);
        //   requestConsentLinks('expired-consent');
        //   return;
        // }

        console.log('**SetBankAccounts UseEffect no consent link requests needed with roundups:', roundups);

    }, [
      roundups.bankConsented,
      roundups.links,
      requestingConsentLinksRef,
      registeringNewShopperForRoundups,
      roundups.accountsConnectingStatus,
      roundups.consentStatus,
      roundups.bankConnected,
    ]);
 
    

    useEffect(() => {

      console.log('useEffect SetBankAccounts timer triggered', roundups?.links);
      
      const links = roundups?.links || [];
      const timers = [];

      const scheduleRefresh = (link, requestingRef) => {
        
        if (!link?.created_at) {
          console.log('SetBankAccounts scheduleRefresh - no requestFn provided, skipping');
          return;
        }

        const createdAt = moment(link.created_at, 'YYYY-MM-DD HH:mm:ss');

        console.log('SetBankAccounts Link RAW created_at:', link.created_at);
        console.log('SetBankAccounts Link PARSED createdAt:', createdAt.format());
        console.log('SetBankAccounts Link NOW:', moment.utc().format());
        
        const expiry = createdAt.clone().add(1, 'hour');  //(7, 'minutes');//
        const triggerTime = expiry.clone().subtract(5, 'minutes');

        const now = moment.utc();
        const delay = triggerTime.diff(now);

        console.log('useEffect SetBankAccounts timer delay(ms):', delay);

        const trigger = () => {
          if (requestingRef?.current) {
            console.log('SetBankAccounts schduleRefresh trigger - Skipping request, already in progress');
            return;
          }
          if (!link?.link_type) {
            console.log('SetBankAccounts scheduleRefresh trigger - Missing link_type, cannot request consent link');
            return;
          }
          console.log('SetBankAccounts scheduleRefresh trigger - Requesting new link.link_type: ', link.link_type);
          requestConsentLinks(link.link_type)
        };

        if (delay <= 0) {
          trigger();
          return;
        }

        const timer = setTimeout(trigger, delay);
        timers.push(timer);
      };

      const TARGET_LINK_TYPES = new Set([
        'reconnect-consent',
        'consent',
        'manage-consent',
        'extend-consent',
        'expired-consent',
      ]);
    
      links
        .filter((l) => TARGET_LINK_TYPES.has(l?.link_type))
        .forEach((link) =>
          scheduleRefresh(link, requestingConsentLinksRef)
        );

      return () => {
        console.log('SetBankAccounts scheduleRefresh Cleaning up timers');
        timers.forEach(clearTimeout);
      };
    }, [
      roundups?.links,
      requestingConsentLinksRef,
    ]);

  const handleSyncAccountClick = () => {
    console.log('handleSyncAccountClick triggered with roundups: ', roundups);
    syncShopperDataFromOpenBank();
  };


  const handleDeleteBankClick = () => {
    console.log('handleSyncAccountClick triggered with roundups: ', roundups);
    deleteBankConnection();
  };

  const isLinkExpired = (link) => {
    if (!link?.created_at) return true;
  
    const createdAt = moment.isMoment(link.created_at)
    ? link.created_at.clone().utc()
    : moment.utc(link.created_at, 'YYYY-MM-DD HH:mm:ss');

    console.log('SetBankAccounts Link RAW created_at:', link.created_at);
    console.log('SetBankAccounts Link PARSED createdAt:', createdAt.format());
    console.log('SetBankAccounts Link NOW:', moment.utc().format());

    const expiryTime = createdAt.add(1, 'hour');
  
    return moment.utc().isAfter(expiryTime);
  };

  const hasValidConsentLink = Array.isArray(roundups?.links) &&
  roundups.links.some(
    (link) =>
      link?.link_type === 'connect' &&
      !link?.expired &&
      !isLinkExpired(link)
  );
  

  
  return (
    <SetBankAccountsWrapper>
    <div className="content-container">
      {
           registeringNewShopperForRoundups ?
        (
          <div className="waiting">
            <h1>Setting up your Round Ups account</h1>
            {/* <p>{merchantName} will {rate}</p> */}
            <p>Please wait while we set up your Round Ups account</p>
            <p>1. Registering Account for Round Ups</p>
            <p>2. Creating user profile for Open Banking</p>
            <BarLoader
              sizeUnit={"px"}
              size={400}
              color="#000"
              loading={true}
            />
          </div>
        ) : (
          <div className="bank-accounts-container">
            {(roundups.linkedAccounts && roundups.linkedAccounts.length > 0) ? 
              null : (
                <Container fluid className="links-container" style={{ margin: 0, padding: 0, width: '100%' }}>
                  <Row style={{ margin: 0, padding: 0, width: '100%' }}>
                    <Col xl={6} lg={6} md={12} sm={12} xs={12} className="links-group" style={{ margin: 0, padding: 0 }}>
                      {connectYourBankInfoCard}
                    </Col>
                    {shouldShowManageConsentCard && (
                      <Col xl={6} lg={6} md={6} sm={12} xs={12} className="links-group" style={{ margin: 0, padding: 0 }}>
                        {manageConsentInfoCard}
                      </Col>
                    )}

                    <Col xl={6} lg={6} md={12} sm={12} xs={12} className="links-group" style={{ margin: 0, padding: 0 }}>
                      {aboutOpenBankingInfoCard}
                    </Col>
                  </Row>
                </Container>
              )}
            <h2 className="title">Your Linked Accounts</h2>
            {
              roundups.accountsConnectingStatus === 'deleting' ?
                ( <div className="waiting">
                    <p>We are deleting your approval and removing any accounts connected.</p>
                    <p>This process normally takes 3-5 minutes. You will only be able to connect another bank after the process is complete.</p>
                    <BarLoader 
                      label='Loading...'
                      height={4} 
                      width={50} 
                      loading={true}
                    />
                  </div>
                )
              : roundups.accountsConnectingStatus === 'retrieving' ?
                (
                  <div className="waiting">
                    <p>We have successfully connected your bank.</p>
                    <p>We are now retrieving your accounts. It could take up to 30 minutes. You may leave this page and return later.</p>
                    <p>Once your accounts are retrieved you will need to ensure <strong>Round Ups are enabled on the account</strong>.</p>
                    <BarLoader 
                      label='Loading...'
                      height={4} 
                      width={50}
                      size={200} 
                      sizeUnit={"px"} 
                      loading={true}
                    />
                  </div>
                )

            : (roundups.linkedAccounts && roundups.linkedAccounts.length > 0) ? 
                (
                  <div>
                    <RoundUpsAcctsTable
                      onError={onError}
                    />
                    <div className="button-container">
                      <ActionButton
                        text="Connect Another Bank"
                        onClick={() =>  handleConnectBank() }
                        color="#fff"
                        large={true}
                        disabled={!hasValidConsentLink}
                      />
                      { !hasValidConsentLink ?  
                        (
                          <div>
                            <p> Please wait a moment. Setting up link for BASIQ Open Banking connection</p>
                            <BarLoader
                              sizeUnit={"px"}
                              size={400}
                              color="#000"
                              loading={true}
                            />
                          </div>
                          )
                          : <p>You will be taken to the BASIQ Open Banking portal to link your bank account.</p> 
                      }
                    </div>

                    <Container
                      fluid
                      className="links-container"
                      style={{
                        margin: 0,
                        padding: 0,
                        width: '100%',
                      }}
                    >
                      <Row
                        style={{
                          margin: 0,
                          padding: 0,
                          width: '100%',
                        }}
                      >
                        <Col
                          xl={6}
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="links-group"
                          style={{
                            margin: 0,
                            padding: 0,
                          }}
                        >
                          {manageConsentInfoCard}

                          <ActionButton
                            text="Delete All Connected Banks"
                            onClick={() => setShowModalDialogV3(true)}
                            color="#fff"
                            large={false}
                            disabled={!roundups.consentLinkStatus}
                          />
                        </Col>

                        {hasAcceptedDDR && (
                          <Col
                            xl={6}
                            lg={6}
                            md={6}
                            sm={12}
                            xs={12}
                            className="links-group"
                            style={{
                              margin: 0,
                              padding: 0,
                            }}
                          >
                            {viewDDRSAInfoCard}
                          </Col>
                        )}

                        <Col
                          xl={6}
                          lg={6}
                          md={12}
                          sm={12}
                          xs={12}
                          className="links-group"
                          style={{
                            margin: 0,
                            padding: 0,
                          }}
                        >
                          {aboutOpenBankingInfoCard}
                        </Col>
                      </Row>
                    </Container>
                    

                  </div>
                )
            : ( 
                <div className="waiting">
                  <p>You have no linked Accounts. Start by connecting a bank.</p>
                </div>
                )

            }
          </div>
          
        )
  }
    </div>
    <div>
        <ModalDialogV3 //remove MOdalDialog in final code - no need modal for deleting accts
          open={showModalDialogV3}
          onCloseModalDialogV3={() => setShowModalDialogV3(false)}
          titleComponent={"Are You Sure?"}
          errorMessage={"All connected bank accounts will be removed from your account."}
          explainerComponent={
            <p>You will have to add them back each individually to connect them again to our Round Ups service.</p>
          }
          contentComponent={
            <ActionButton
              text="Yes - Delete All Connected Banks"
              onClick={() =>  handleDeleteBankClick() }
              color="#fff"
              large={false}
              disabled={roundups.consentLinkStatus ? false : true}
            />
          }
        />

        <ModalDialogV3
          open={showDDRViewModal}
          onCloseModalDialogV3={() => {
            console.log(
              'SetBankAccounts - closing View Direct Debit Request modal'
            );

            setShowDDRViewModal(false);
          }}
          titleComponent="Zai Australia Pty Ltd Direct Debit Request Service Agreement"
          explainerComponent={null}
          contentComponent={
            <DirectDebitRequestContent
              mode="view"
              acceptedRoundupsTerms={hasAcceptedDDR}
            />
          }
        />
    </div>
    </SetBankAccountsWrapper>
  );
}

export default SetBankAccounts;